
import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import moment from 'moment';
import UTILS from '@/lib/UTILS';
import { Task } from '@/types';
import DatePickerDialog from '@/components/DatePickerDialog.vue';

@Component({
  components: {
    DatePickerDialog,
  },
})
export default class TaskPFollowUpDialog extends Vue {
  @Prop(Boolean) readonly value!: boolean;
  @Prop(Object) readonly task!: Task;

  dialog = false
  valid = false
  loading = false

  noteFollowUp: string | null = null
  dataFollowUp: Date | null = null

  datePickerDialog = false
  datePickerDate: string | null = null

  @Watch('value')
  onValueChange(val: boolean) {
    if (val === true) {
      this.noteFollowUp = this.cvNoteFollowUp || null;
      this.dataFollowUp = this.cvDataFollowUp || null;
    }

    this.dialog = val;
  }

  @Watch('dialog')
  onDialogChange(val: boolean) {
    if (this.value !== val) {
      this.$emit('input', val);
    }
  }

  get user() {
    return this.$store.getters.currentUser;
  }

  get lead() {
    return this.$store.getters.currentLead;
  }

  get cvNoteFollowUp() {
    return this.getCustomValueTextByName('noteFollowUp');
  }

  get cvDataFollowUp() {
    return this.getCustomValueDateByName('dataFollowUp');
  }

  getCustomValueTextByName(name: string) {
    return UTILS.getCustomValueTextByName(this.lead, name);
  }

  getCustomValueDateByName(name: string) {
    return UTILS.getCustomValueDateByName(this.lead, name);
  }

  mDate(date: Date): string {
    return moment(date).format('L');
  }

  onClickDate() {
    console.log(`${this.constructor.name}: onClickDate()`); // eslint-disable-line no-console

    // Imposta l'eventuale data precedentemente selezionata
    this.datePickerDate = this.dataFollowUp
      ? moment(this.dataFollowUp).toISOString(true).substring(0, 10)
      : null;

    this.datePickerDialog = true;
  }

  async onClearDate() {
    console.log(`${this.constructor.name}: onClearDate()`); // eslint-disable-line no-console

    this.dataFollowUp = null;
  }

  onSelectDate(date: string | null) {
    console.log(`${this.constructor.name}: onSelectDate() date =`, date); // eslint-disable-line no-console

    // Chiudo il dialog per la selezione della data
    this.datePickerDialog = false;

    // Trasforma in un valore di tipo Date prima di restituirlo
    const selectedDate = date
      ? moment(date, 'YYYY-MM-DD').toDate()
      : null;

    this.dataFollowUp = selectedDate;
  }

  onCancel() {
    this.dialog = false;
  }

  async onConfirm() {
    this.loading = true;

    await this.$store.dispatch('updateLead', {
      updateType: 'task',
      update: {
        task: this.task,
        cvDataFollowUp: this.dataFollowUp,
        cvNoteFollowUp: this.noteFollowUp || '',
      },
    });

    this.dialog = false;
    setTimeout(() => {
      this.loading = false;
    }, 500);
  }

  async onDelete() {
    this.loading = true;

    await this.$store.dispatch('updateLead', {
      updateType: 'task',
      update: {
        task: this.task,
        cvDataFollowUp: null,
        cvNoteFollowUp: '',
      },
    });

    this.dialog = false;
    setTimeout(() => {
      this.loading = false;
    }, 500);
  }
}
